import {
  getOnlineTakebackBrand,
  getOnlineTakebackBrandSlugs,
} from "../core-modules/data";

import Head from "next/head";
import React from "react";
import ResetScrollOnStepChange from "../components/ResetScrollOnStepChange";
import OnlineTakeback from "../components/OnlineTakeback";
import { BrandProvider } from "../components/BrandContext";
import { TakebackConfigProvider } from "../components/TakebackConfigContext";
import AppContextProvider from "../components/AppContext";

function OnlineTakebackPage({ brand, takebackConfig }) {
  const { headerImageUrls, metaTitle, metaDescription } = takebackConfig;

  return (
    <AppContextProvider>
      <BrandProvider brand={brand}>
        <TakebackConfigProvider takebackConfig={takebackConfig}>
          <Head>
            <meta property="og:title" content={metaTitle} />
            <meta name="description" content={metaDescription} />
            <meta property="og:description" content={metaDescription} />
            {headerImageUrls && (
              <meta property="og:image" content={headerImageUrls[0]} />
            )}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:creator" content="Reskinned.clothing" />
            <meta name="twitter:title" content={metaTitle} />
            <meta name="twitter:description" content={metaDescription} />
          </Head>
          <ResetScrollOnStepChange>
            <OnlineTakeback embedMode={false} />
          </ResetScrollOnStepChange>
        </TakebackConfigProvider>
      </BrandProvider>
    </AppContextProvider>
  );
}

export default OnlineTakebackPage;

export async function getStaticProps({ params }) {
  const brand = await getOnlineTakebackBrand(params.slug);
  if (!brand) {
    return {
      notFound: true,
    };
  }
  return {
    props: { brand, takebackConfig: brand.takebackConfig },
    revalidate: 60,
  };
}

export async function getStaticPaths() {
  const { brands, errors } = await getOnlineTakebackBrandSlugs();

  const paths = errors.length
    ? []
    : brands.map((brand) => {
        return `/${brand.slug}`;
      });

  return {
    paths,
    fallback: "blocking",
  };
}
